import {makeAutoObservable, reaction} from "mobx";
import {NumberObservable} from "../../../observables/numberObservable";

export class EventTemplateDuration {
  hours: NumberObservable;
  minutes: NumberObservable;
  isDirty: boolean = false;

  private maxHours = 4;
  private maxMinutes = 59;
  constructor(hours?: number, minutes?: number) {
    makeAutoObservable(this);
    this.hours = new NumberObservable(
      hours ?? 0,
      0,
      this.maxHours,
      0,
      (hours) => {
        if (hours === undefined) {
          return false;
        }

        const isWithinRange = hours >= 0 && hours <= this.maxHours;

        return isWithinRange;
      }
    );
    this.minutes = new NumberObservable(
      minutes ?? 0,
      0,
      this.maxMinutes,
      0,
      (minutes) => {
        if (minutes === undefined) {
          return false;
        }

        const isWithinRange = minutes >= 0 && minutes <= this.maxMinutes;

        return isWithinRange;
      }
    );

    reaction(
      () => this.hours.number,
      () => this.setIsDirty(true)
    );
    reaction(
      () => this.minutes.number,
      () => this.setIsDirty(true)
    );
  }

  setIsDirty = (value: boolean) => {
    this.isDirty = value;
  };

  get isValid() {
    return (
      !this.isDirty ||
      (this.hours.isValid &&
        this.minutes.isValid &&
        !this.isSelectedTimeExceedMaxAllowedTime &&
        !this.isSelectedTimeBelowMinAllowedTime)
    );
  }

  get isSelectedTimeExceedMaxAllowedTime() {
    const timeInMinutes =
      (this.hours.number ?? 0) * 60 + (this.minutes.number ?? 0);

    return timeInMinutes > this.maxHours * 60;
  }

  get isSelectedTimeBelowMinAllowedTime() {
    return this.hours.number === 0 && this.minutes.number === 0;
  }
}
